import React from 'react'
import PanelHead from '../../UI/Panel/PanelHead';
import PanelBody from '../../UI/Panel/PanelBody';
import { CategoryTable } from '../../UI/Categories/CategoryTable';

const Categories = () => {
  return (
    <div>
      <PanelHead title="Categories" />
      <PanelBody content={<CategoryTable />} />
    </div>
  )
}

export default Categories;